import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import store from 'store/Store'
import {Provider} from 'react-redux'
import {LoaderProvider} from 'context/LoaderContext'
import {ColorModeProvider} from 'context/ColorModeContext'

// import reportWebVitals from './reportWebVitals'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <Provider store={store}>
        <LoaderProvider>
            <ColorModeProvider>
                <App tab="home" />
            </ColorModeProvider>
        </LoaderProvider>
    </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
